module.exports = __webpack_public_path__ + "img/hr-wooden-particle-13.e61b3742.png";